import { Certificate } from "pmt-types/src/models/Certificate.ts";
import { Enrollee } from "pmt-types/src/models/Enrollee.ts";
import { Project } from "pmt-types/src/models/Project.ts";
import { Source } from "pmt-types/src/models/Source.ts";
import { useState } from "react";
import ErrorLabel from "../../components/form/errorLabel.tsx";
import SearchPage from "../../components/search/searchPage.tsx";
import { useMutationDownloadCertificate } from "../../hooks/mutations/useMutationDownloadCertificate.ts";
import cx from "../../utils/cx.ts";
import formatDateString from "../../utils/formatDateString.ts";
import { Maybe } from "../../utils/types/maybe.ts";

export default function CertificatesList() {
  const {
    mutate: generatePdfLink,
    isLoading: isPdfLinkLoading,
    error,
  } = useMutationDownloadCertificate();
  const [loadingCertificate, setLoadingCertificate] =
    useState<Maybe<Certificate>>(null);

  return (
    <>
      {error != null && <ErrorLabel message={error?.toString()} />}
      <SearchPage<Certificate>
        route="certificates"
        showSearchBar={false}
        resultsColumnDef={[
          {
            accessorKey: "source",
            id: "source",
            cell: (info) => (info.getValue() as Source)?.name,
            header: "Source",
          },
          {
            accessorKey: "project",
            id: "project",
            cell: (info) => (info.getValue() as Project)?.name,
            header: "Project",
          },
          {
            accessorKey: "enrollee",
            id: "enrollee",
            cell: (info) => (info.getValue() as Enrollee)?.name,
            header: "Enrollee",
          },
          {
            accessorKey: "updatedDate",
            id: "updatedDate",
            cell: (info) => formatDateString(info.getValue() as string),
            header: "Created",
          },
          {
            id: "view",
            cell: (info) => (
              <a
                onClick={() => {
                  if (isPdfLinkLoading) {
                    return false;
                  }

                  const certificate = info.row.original as Certificate;

                  setLoadingCertificate(certificate);

                  generatePdfLink(certificate, {
                    onSuccess: (data) => {
                      window.open(data.url, "_blank", "noreferrer");
                    },
                    onError: (error) =>
                      console.error("Error generating pdf link", error),
                  });
                }}
                className={cx(
                  isPdfLinkLoading &&
                    loadingCertificate?.id == info.row.original.id
                    ? "text-slate-600 hover:text-slate-900"
                    : "text-sky-600 hover:text-sky-900",
                  "hover:cursor-pointer",
                )}
              >
                View<span className="sr-only">, {info.row.index}</span>
              </a>
            ),
            header: "",
            maxSize: 50,
          },
        ]}
      />
    </>
  );
}
